/* eslint-disable max-lines */

import { FDealType, FOfferType, isAvailable, isAvailableStrict } from '../../../../../JsonQuery';
import { TFilter } from '../../../types/advancedFilters';
import { IJsonQuery } from '../../../types/jsonQuery';

interface IFilterList {
  availability(jsonQuery: IJsonQuery): boolean;
  list: TFilter[];
}

const FILTERS_LIST: IFilterList[] = [
  {
    availability: isAvailableStrict(FDealType.Sale, FOfferType.FlatNew),
    list: [
      'withNeighbors',
      'completionYear',
      'undergroundTime',
      'offerType',
      'squareMeterArea',
      'layout',
      // Видео
      // Наличие фото
      // Тип объявления
      'ceilingHeight',
      'floor',
      'floors',
      'constructionType',
      'decorationsList',
      'saleType',
      'apartments',
      'publicationDate',
      'containWords',
      'excludeWords',
      'contact',
      'offerId',
    ],
  },
  {
    availability: isAvailable(FDealType.Sale, FOfferType.Flat),
    list: [
      'withNeighbors',
      'dealType',
      'undergroundTime',
      'squareMeterArea',
      'layout',
      'ceilingHeight',
      'urbanBathroom',
      'balcony',
      'kitchenStove',
      'repair',
      'floor',
      'floors',
      'windows',
      'constructionYear',
      'constructionType',
      // Серия дома
      'demolition',
      'elevators',
      // Пандус
      'parking',
      'saleType',
      'apartments',
      'publicationDate',
      'containWords',
      'excludeWords',
      'contact',
      'offerId',
    ],
  },
  {
    availability: isAvailable(FDealType.Sale, FOfferType.Room),
    list: [
      'withNeighbors',
      'dealType',
      'undergroundTime',
      'squareMeterArea',
      'flatRooms',
      'roomsInDeal',
      'layout',
      'ceilingHeight',
      'urbanBathroom',
      'balcony',
      'kitchenStove',
      'repair',
      'floor',
      'floors',
      'windows',
      'constructionYear',
      'constructionType',
      'demolition',
      'elevators',
      'parking',
      'saleType',
      'publicationDate',
      'containWords',
      'excludeWords',
      'contact',
      'offerId',
    ],
  },
  {
    availability: isAvailable(FDealType.Sale, FOfferType.FlatShared),
    list: [
      'withNeighbors',
      'dealType',
      'undergroundTime',
      'squareMeterArea',
      'flatRooms',
      'layout',
      'ceilingHeight',
      'urbanBathroom',
      'balcony',
      'kitchenStove',
      'repair',
      'floor',
      'floors',
      'windows',
      'constructionYear',
      'constructionType',
      'demolition',
      'elevators',
      'parking',
      'saleType',
      'apartments',
      'publicationDate',
      'containWords',
      'excludeWords',
      'contact',
      'offerId',
    ],
  },
  {
    availability: isAvailableStrict(FDealType.Sale, FOfferType.House),
    list: [
      'suburbanHouseType',
      'withNeighbors',
      'fromMKAD',
      'undergroundTime',
      'suburbanArea',
      'constructionType',
      'heatingType',
      'suburbanUtilities',
      'suburbanFacilities',
      'landStatus',
      'floors',
      'bedrooms',
      'suburbanBathroom',
      'constructionYear',
      'possessor',
      'publicationDate',
      'containWords',
      'excludeWords',
      'contact',
      'offerId',
    ],
  },
  {
    availability: isAvailable(FDealType.Sale, FOfferType.House | FOfferType.HousePart | FOfferType.Townhouse),
    list: [
      'withNeighbors',
      'fromMKAD',
      'undergroundTime',
      'suburbanArea',
      'constructionType',
      'heatingType',
      'suburbanUtilities',
      'landStatus',
      'floors',
      'bedrooms',
      'suburbanBathroom',
      'constructionYear',
      'suburbanFacilities',
      'possessor',
      'publicationDate',
      'containWords',
      'excludeWords',
      'contact',
      'offerId',
    ],
  },
  {
    availability: isAvailable(FDealType.Sale, FOfferType.Land),
    list: [
      'withNeighbors',
      'fromMKAD',
      'undergroundTime',
      'suburbanArea',
      'suburbanUtilities',
      'landStatus',
      'possessor',
      'publicationDate',
      'containWords',
      'excludeWords',
      'contact',
      'offerId',
    ],
  },
  {
    availability: isAvailable(FDealType.Sale, FOfferType.Garage),
    list: [
      'undergroundTime',
      'squareMeterArea',
      'garageType',
      'garageStatus',
      'garageUtilities',
      'parking',
      'publicationDate',
      'containWords',
      'excludeWords',
      'contact',
      'offerId',
    ],
  },

  {
    availability: isAvailable(FDealType.RentLongterm, FOfferType.Flat),
    list: [
      'withNeighbors',
      'dealType',
      'rentalPeriod',
      'undergroundTime',
      'facilities',
      'livingConditions',
      'squareMeterArea',
      'layout',
      'apartments',
      'ceilingHeight',
      'urbanBathroom',
      'balcony',
      'bathType',
      'kitchenStove',
      'repair',
      'windows',
      'floor',
      'floors',
      'constructionYear',
      'constructionType',
      'demolition',
      'elevators',
      // Пандус
      'parking',
      'rentTerms',
      'publicationDate',
      'containWords',
      'excludeWords',
      'contact',
      'offerId',
    ],
  },
  {
    availability: isAvailable(FDealType.RentLongterm, FOfferType.Room),
    list: [
      'withNeighbors',
      'dealType',
      'rentalPeriod',
      'undergroundTime',
      'facilities',
      'livingConditions',
      'squareMeterArea',
      'flatRooms',
      'roomsInDeal',
      'layout',
      'ceilingHeight',
      'urbanBathroom',
      'balcony',
      'bathType',
      'kitchenStove',
      'repair',
      'floor',
      'floors',
      'windows',
      'constructionYear',
      'constructionType',
      'demolition',
      'elevators',
      // Пандус
      'parking',
      // Состав съемщиков
      'rentTerms',
      'publicationDate',
      'containWords',
      'excludeWords',
      'contact',
      'offerId',
    ],
  },
  {
    availability: isAvailable(FDealType.RentLongterm, FOfferType.Bed),
    list: [
      'withNeighbors',
      'dealType',
      'rentalPeriod',
      'undergroundTime',
      'facilities',
      'livingConditions',
      'squareMeterArea',
      'flatRooms',
      'roomsInDeal',
      'layout',
      'ceilingHeight',
      'urbanBathroom',
      'balcony',
      'bathType',
      'kitchenStove',
      'repair',
      'floor',
      'floors',
      'windows',
      'constructionYear',
      'constructionType',
      'elevators',
      // Пандус
      'parking',
      // Состав съемщиков
      'rentTerms',
      'publicationDate',
      'containWords',
      'excludeWords',
      'contact',
      'offerId',
    ],
  },
  {
    availability: isAvailable(FDealType.RentLongterm, FOfferType.House | FOfferType.HousePart | FOfferType.Townhouse),
    list: [
      'withNeighbors',
      'rentalPeriod',
      'fromMKAD',
      'undergroundTime',
      'suburbanArea',
      'facilities',
      'suburbanFacilities',
      'bathType',
      'suburbanBathroom',
      'repair',
      'floors',
      'constructionType',
      'heatingType',
      'constructionYear',
      'rentTerms',
      'livingConditions',
      'publicationDate',
      'dealType',
      'containWords',
      'excludeWords',
      'contact',
      'offerId',
    ],
  },
  {
    availability: isAvailable(FDealType.RentLongterm, FOfferType.Garage),
    list: [
      'undergroundTime',
      'squareMeterArea',
      'garageType',
      'garageStatus',
      'garageUtilities',
      'parking',
      'publicationDate',
      'containWords',
      'excludeWords',
      'contact',
      'offerId',
    ],
  },
  {
    availability: isAvailable(FDealType.RentDaily, FOfferType.Flat),
    list: [
      'withNeighbors',
      'dealType',
      'undergroundTime',
      'facilities',
      'livingConditions',
      'squareMeterArea',
      'apartments',
      'ceilingHeight',
      'urbanBathroom',
      'balcony',
      'bathType',
      'kitchenStove',
      'repair',
      'floor',
      'floors',
      'windows',
      'constructionYear',
      'constructionType',
      'elevators',
      // Пандус
      'parking',
      'publicationDate',
      'containWords',
      'excludeWords',
      'contact',
      'offerId',
    ],
  },
  {
    availability: isAvailable(FDealType.RentDaily, FOfferType.Room | FOfferType.Bed),
    list: [
      'withNeighbors',
      'dealType',
      'undergroundTime',
      'facilities',
      'livingConditions',
      'squareMeterArea',
      'flatRooms',
      'roomsInDeal',
      'ceilingHeight',
      'urbanBathroom',
      'balcony',
      'bathType',
      'kitchenStove',
      'repair',
      'floor',
      'floors',
      'windows',
      'constructionYear',
      'constructionType',
      'elevators',
      // Пандус
      'parking',
      // Состав съемщиков
      'publicationDate',
      'containWords',
      'excludeWords',
      'contact',
      'offerId',
    ],
  },
  {
    availability: isAvailable(FDealType.RentDaily, FOfferType.House),
    list: [
      'withNeighbors',
      'fromMKAD',
      'undergroundTime',
      'suburbanAreaDailyrent',
      'facilities',
      'livingConditions',
      'suburbanFacilities',
      'bathType',
      'suburbanBathroom',
      'repair',
      'floors',
      'constructionType',
      'heatingType',
      'constructionYear',
      'publicationDate',
      'dealType',
      'containWords',
      'excludeWords',
      'contact',
      'offerId',
    ],
  },
  {
    availability: isAvailable(FDealType.Any, FOfferType.Any),
    list: ['withNeighbors', 'publicationDate', 'containWords', 'excludeWords', 'contact', 'offerId'],
  },
];

export function getAvailableFilters(jsonQuery: IJsonQuery): TFilter[] {
  const type = FILTERS_LIST.find((f: IFilterList) => f.availability(jsonQuery));

  return (type && type.list) || [];
}
